<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-6">
          <strong class="card-title mb-3">{{'Analysis'}} - {{mfSCHCode}} {{(rawData.length)? rawData[0]['SCH_NAME']: ''}}</strong>
        </div>
        <div class="col-md-5">          
        </div>
        <div class="col-md-1">
          <!-- <goback></goback> -->
          <div class="pull-right">
            <router-link class="btn btn-sm" :to="'/mutual-funds/rawdata'"><i class="fa fa-caret-left"></i> Go Back</router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row mb5" >
        <div class="col-md-3">
          <div class="form-group">
            <datepicker
              :input-class="'form-control'"
              :format="'dd-MM-yyyy'"
              v-model="durDate"
              @selected="getDateData($event)"
              :disabledDates="disabledDates"
              :placeholder="'Select Date'"
            ></datepicker>
          </div>
        </div>
      </div>
      <div class="row mb5">
        <div class="col-md-6">
          </div>
        </div>
        <div class="mb5"></div>
        <div class="row mb5">
          <div class="col-md-2">
            <span v-if="rawData.length"><strong>Date: {{rawData.length? getDate(sum.date): ''}}</strong></span>
          </div>
          <div class="col-md-3">
            <span v-if="rawData.length"><strong>Sum P11 S (% hldg):</strong> {{rawData.length? getChecknFixed(sum['p11_S_%_hldg_sum']): ''}}</span>
          </div>
          <div class="col-md-3">
            <span v-if="rawData.length"><strong>Sum P11 quarterly trends (% hldg):</strong> {{rawData.length? getChecknFixed(sum['p11_quarterly_trends_%_hldg_sum']): ''}}</span>
          </div>
          <div class="col-md-3">
            <span v-if="rawData.length"><strong>Sum QA Or QB Greater (% hldg):</strong> {{rawData.length? getChecknFixed(sum['q1_a_b_greater_%_hldg_sum']): ''}}</span>
          </div>
          <div class="col-md-1">
            <download :tableId="rawDataType" :fileName="rawDataType"></download>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-3">
            <span v-if="rawData.length"><strong>Debt rating (% hldg):</strong> {{rawData.length? getChecknFixed(sum['p11_debt_%_hldg_sum']): ''}}</span>
          </div>
          <div class="col-md-3">
            <span v-if="rawData.length"><strong>Portfolio Overall Rating:</strong> {{rawData.length? getChecknFixed(sum.portfolio_overall_rating): ''}}</span>
          </div>
        </div>
        <div class="table-responsive scrollbar app" v-dragscroll="true" v-if="tableFields.length">
          <table :id="rawDataType" class="table table-bordered fonts11 app-inner">
            <thead>
              <tr>
                <th>Sr.</th>
                <th
                  class="data-cell"
                  v-for="(field, index, key) in tableFields"
                  v-bind:key="'field'+field.rowind+index+key"
                >{{field.name}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(tr, ind) in rawData" v-bind:key="'trBod'+'-'+ind">
                <td>
                  <span v-if="rawDataType=='schemes'">
                    <span v-if="page>1">{{(perPage * (page-1)) + (ind+1)}}</span>
                    <span v-else>{{ind+1}}</span>
                  </span>
                  <span v-else>{{ind+1}}</span>
                </td>
                <td
                  v-for="(cl, index) in tableFields"
                  v-bind:key="index+'cldata'+cl.title"
                >
                <span v-if="cl.isLink">
                  <a class="a-btn">{{tr[cl.title]}}</a>
                </span>
                <span v-else>
                  <span v-if="cl.datatype=='date'">{{(tr[cl.title])? getDate(tr[cl.title]): '-'}}</span>
                  <span v-else-if="cl.datatype=='numeric'">{{getChecknFixed(tr[cl.title])}}</span>
                  <span v-else-if="cl.datatype=='rating'">
                    <star-rating v-bind:increment="0.5"
                          v-bind:max-rating="(cl.title=='p11_rating')? 7:5"
                          :rating="parseInt(tr[cl.title])"
                          :read-only="true"
                          :show-rating="false"
                          inactive-color="#868e96"
                          active-color="#ffbf00"
                          v-bind:star-size="20"
                        ></star-rating>
                    </span>
                  <span v-else>{{(tr[cl.title])? tr[cl.title]: '-'}}</span>
                </span>
                </td>
              </tr>
              <tr v-if="rawData.length">
                <td class="text-bold">SUM</td>
                <td class="text-bold"
                  v-for="(cl, index) in tableFields"
                  v-bind:key="index+'cldata'+cl.title"
                >
                  <span v-if="cl.datatype=='numeric'">{{(sum[cl.title+'_sum'])? getChecknFixed(sum[cl.title+'_sum']): '-'}}</span>
                  <span v-else>{{(sum[cl.title+'_sum'])? sum[cl.title+'_sum']: ''}}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row mb5" v-if="!tableFields.length">
          <div class="col-md-12"><div class="alert alert-danger" role="alert">No data found!</div></div>
        </div>
    </div>
  </div>
  <!-- </card> -->
</template>
<script>
import { VueTabs, VTab } from "vue-nav-tabs";
import "vue-nav-tabs/themes/vue-tabs.scss";
import StarRating from "vue-star-rating";
import Datepicker from "vuejs-datepicker";

import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
import { rawMixins } from "../../assets/mixins/rawMixins.js";

export default {
  components: { VueTabs, VTab, StarRating, Datepicker },
  mixins: [commonMixins, rawMixins],
  created() {
    console.log('PARAM', this.$route.params.id);
    if(this.$route.params.id) {
      this.showSchemeHoldings(this.$route.params.id);
      this.mfSCHCode = this.$route.params.id;
      this.mfSCHCode = this.$route.params.id;
    } else {
      this.rawData = [];
    }
    console.log("Rawtype", this.rawDataType, this.mfSCHCode);
  },
  methods: {
    showSchemeHoldings(mfcode) {
      console.log('mfcode', mfcode);
      this.rawData = [];
      // this.tableFields = [];
      let myself = this;
      var APIUrl = this.rawDataApi + 'analysis/' + mfcode;
      if(this.durDate!=null) {
        APIUrl = APIUrl + '?date=' + this.getYMDDate(this.durDate);
      }
      http.get(
        APIUrl,
        {},
        (error, response) => {
          console.log("Response", response.data);
          if(response.status == 'success') {
            this.rawData = response.data.length > 0 ? response.data : [];
            this.sum = response.data.length? response.sum: [];
            console.log(this.rawData);
            if(response.data.length>0) {
              // var tableKeys = Object.keys(this.rawData[0]);
              // tableKeys.forEach((tf, key) => {
              //   if(tf != '_id') {
              //     this.tableFields.push({
              //       title: tf,
              //       name: this.getLabel(tf),
              //       rowind: 0,
              //       isLink: 0,
              //       datatype: (tf=='INVDATE')? 'date': (tf=='market_capitalization')? 'numeric': '',
              //       sort_order: (tf=='CO_CODE')? 1: (tf=='CO_NAME')? 2
              //       : (tf=='bsegroup')? 3
              //       : (tf=='bsecode')? 4
              //       : (tf=='nsesymbol')? 5
              //       : (tf=='industrycode')? 6
              //       : (tf=='industryname')? 7
              //       : (tf=='sectorname')? 8
              //       : (tf=='sectorname')? 7
              //       : (tf=='govtflag')? 10
              //       : (tf=='mcaptype')? 11
              //       : (tf=='market_capitalization')? 12
              //       : (tf=='p1_S')? 11
              //       : (tf=='p1_S_%_hldg')? 12
              //       : (tf=='p2_S')? 11
              //       : (tf=='p2_S_%_hldg')? 12
              //       : (tf=='p3_S')? 11
              //       : (tf=='p3_S_%_hldg')? 12
              //       : (tf=='p4_S')? 11
              //       : (tf=='p4_S_%_hldg')? 12
              //       : (tf=='p5_a_S')? 11
              //       : (tf=='p5_a_S_%_hldg')? 12
              //       : (tf=='p5_b_S')? 11
              //       : (tf=='p5_b_S_%_hldg')? 12
              //       : (tf=='p6_a')? 11
              //       : (tf=='p6_a_%_hldg')? 12
              //       : (tf=='p7_a_S')? 11
              //       : (tf=='p7_a_S_%_hldg')? 12
              //       : (tf=='p7_b_S')? 11
              //       : (tf=='p7_b_S_%_hldg')? 12
              //       : (tf=='p8_a_S')? 11
              //       : (tf=='p8_a_S_%_hldg')? 12
              //       : (tf=='p8_b_S')? 11
              //       : (tf=='p8_b_S_%_hldg')? 12
              //       : (tf=='p9_S')? 11
              //       : (tf=='p9_S_%_hldg')? 12
              //       : (tf=='p10_S')? 11
              //       : (tf=='p10_S_%_hldg')? 12
              //       : (tf=='p11_S')? 11
              //       : (tf=='p11_S_%_hldg')? 12
              //       : (tf=='p11_quarterly_trends')? 11
              //       : (tf=='p11_quarterly_trends_%_hldg')? 12
              //       : (tf=='q1_S')? 11
              //       : (tf=='q1_S_%_hldg')? 12
              //       : (tf=='q1_a_S')? 11
              //       : (tf=='q1_a_S_%_hldg')? 12
              //       : (tf=='q1_b_S')? 11
              //       : (tf=='q1_b_S_%_hldg')? 12
              //       : (tf=='q1_a_b_greater')? 11
              //       : (tf=='q1_a_b_greater_%_hldg')? 12
              //       : (tf=='q1_c_S')? 11
              //       : (tf=='q1_c_S_%_hldg')? 12
              //       : (tf=='q1_d_S')? 11
              //       : (tf=='q1_d_S_%_hldg')? 12
              //       : 99
              //     });
              //   }
              // });
              // this.tableFields = this.sorted_fields_asc(this.tableFields, "sort_order");
            }
          // console.log("this.rawData", this.rawData);
          }
        });
    },
    getDateData(e) {
      console.log("Date Selected", e);
      this.durDate = e;
      this.showSchemeHoldings();
    },
  },
  data() {
    return {
      durDate: null,
      // durDate: new Date().setDate(new Date().getDate() - 1),
      disabledDates: {
        from: new Date(new Date().setDate(new Date().getDate() - 1))
      },
      tableFields: [
          {
          title: 'CO_CODE',
          name: this.getLabel('CO_CODE'),
          isLink: 0,
          datatype: '',
          sort_order: 1
          }, 
          {
            title: 'CO_NAME',
            name: this.getLabel('CO_NAME'),
            isLink: 0,
            datatype: '',
            sort_order: 2
          }, {
            title: 'bsegroup',
            name: this.getLabel('bsegroup'),
            isLink: 0,
            datatype: '',
            sort_order: 3
          }, {
            title: 'bsecode',
            name: this.getLabel('bsecode'),
            isLink: 0,
            datatype: '',
            sort_order: 4
          }, {
            title: 'nsesymbol',
            name: this.getLabel('nsesymbol'),
            isLink: 0,
            datatype: '',
            sort_order: 5
          }, {
            title: 'industrycode',
            name: this.getLabel('industrycode'),
            isLink: 0,
            datatype: '',
            sort_order: 6
          }, {
            title: 'industryname',
            name: this.getLabel('industryname'),
            isLink: 0,
            datatype: '',
            sort_order: 7
          }, {
            title: 'sectorname',
            name: this.getLabel('sectorname'),
            isLink: 0,
            datatype: '',
            sort_order: 8
          }, {
            title: 'govtflag',
            name: this.getLabel('govtflag'),
            isLink: 0,
            datatype: '',
            sort_order: 9
          }, 
          {
            title: '1_year_return',
            name: this.getLabel('1Yr_return'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 10
          },
          {
            title: 'PERC_HOLD',
            name: this.getLabel('PERC_HOLD'),
            isLink: 0,
            datatype: '',
            sort_order: 10
          },
          {
            title: 'mcaptype',
            name: this.getLabel('mcaptype'),
            isLink: 0,
            datatype: '',
            sort_order: 10
          },
          {
            title: 'market_capitalization',
            name: this.getLabel('market_capitalization'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 11
          },          
          {
            title: 'Rating',
            name: this.getLabel('Rating'),
            isLink: 0,
            datatype: '',
            sort_order: 12
          },
          {
            title: 'RatingAgency',
            name: this.getLabel('RatingAgency'),
            isLink: 0,
            datatype: '',
            sort_order: 13
          },
          {
            title: 'p1_S',
            name: this.getLabel('p1_S'),
            isLink: 0,
            datatype: '',
            sort_order: 12
          },
          {
            title: 'p1_S_%_hldg',
            name: this.getLabel('p1_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 13
          },
          {
            title: 'p2_S',
            name: this.getLabel('p2_S'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 14
          },
          {
            title: 'p2_S_%_hldg',
            name: this.getLabel('p2_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 15
          },
          {
            title: 'p3_S',
            name: this.getLabel('p3_S'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 16
          },
          {
            title: 'p3_S_%_hldg',
            name: this.getLabel('p3S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 17
          },
          {
            title: 'p4_S',
            name: this.getLabel('p4_S'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 18
          },
          {
            title: 'p4_S_%_hldg',
            name: this.getLabel('p4_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 19
          },
          {
            title: 'p5_a_S',
            name: this.getLabel('p5_a_S'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 20
          },
          {
            title: 'p5_a_S_%_hldg',
            name: this.getLabel('p5_a_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 20
          },
          {
            title: 'p5_b_S',
            name: this.getLabel('p5_b_S'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 21
          },
          {
            title: 'p5_b_S_%_hldg',
            name: this.getLabel('p5_b_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 21
          },
          {
            title: 'p6_a',
            name: this.getLabel('p6_a'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 22
          },
          {
            title: 'p6_a_%_hldg',
            name: this.getLabel('p6_a_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 23
          },
          {
            title: 'p7_a_S',
            name: this.getLabel('p7_a_S'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 24
          },
          {
            title: 'p7_a_S_%_hldg',
            name: this.getLabel('p7_a_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 25
          },
          {
            title: 'p7_b_S',
            name: this.getLabel('p7_b_S'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 26
          },
          {
            title: 'p7_b_S_%_hldg',
            name: this.getLabel('p7_b_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 27
          },
          {
            title: 'p8_a_S',
            name: this.getLabel('p8_a_S'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 28
          },
          {
            title: 'p8_a_S_%_hldg',
            name: this.getLabel('p8_a_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 29
          },
          {
            title: 'p8_b_S',
            name: this.getLabel('p8_b_S'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 30
          },
          {
            title: 'p8_b_S_%_hldg',
            name: this.getLabel('p8_b_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 31
          },
          {
            title: 'p9_S',
            name: this.getLabel('p9_S'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 32
          },
          {
            title: 'p9_S_%_hldg',
            name: this.getLabel('p9_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 33
          },
          {
            title: 'p10_S',
            name: this.getLabel('p10_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 19
          },
          {
            title: 'p10_S_%_hldg',
            name: this.getLabel('p10_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 34
          },
          {
            title: 'p11_debt_rating',
            name: this.getLabel('p11_debt_rating'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 35
          },
          {
            title: 'p11_debt_%_hldg',
            name: this.getLabel('p11_debt_rating_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 35
          },
          {
            title: 'p11_rating',
            name: this.getLabel('p11_rating'),
            isLink: 0,
            datatype: 'rating',
            sort_order: 35
          },
          {
            title: 'p11_S',
            name: this.getLabel('p11_S'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 35
          },
          {
            title: 'p11_S_%_hldg',
            name: this.getLabel('p11_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 36
          },
          {
            title: 'p11_quarterly_trends_rating',
            name: this.getLabel('p11_quarterly_trends_rating'),
            isLink: 0,
            datatype: 'rating',
            sort_order: 37
          },
          {
            title: 'p11_quarterly_trends',
            name: this.getLabel('p11_quarterly_trends'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 37
          },
          {
            title: 'p11_quarterly_trends_%_hldg',
            name: this.getLabel('p11_quarterly_trends_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 38
          },
          {
            title: 'q1_S',
            name: this.getLabel('q1_S'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 39
          },
          {
            title: 'q1_S_%_hldg',
            name: this.getLabel('q1_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 40
          },
          {
            title: 'q1_a_S',
            name: this.getLabel('q1_a_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 41
          },
          {
            title: 'q1_a_S_%_hldg',
            name: this.getLabel('q1_a_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 42
          },
          {
            title: 'q1_b_S',
            name: this.getLabel('q1_b_S'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 43
          },
          {
            title: 'q1_b_S_%_hldg',
            name: this.getLabel('q1_b_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 44
          },
          {
            title: 'q1_a_or_b_greater_rating',
            name: this.getLabel('q1_a_or_b_greater_rating'),
            isLink: 0,
            datatype: 'rating',
            sort_order: 45
          },
          {
            title: 'q1_a_b_greater',
            name: this.getLabel('q1_a_b_greater'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 45
          },
          {
            title: 'q1_a_b_greater_%_hldg',
            name: this.getLabel('q1_a_b_greater_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 46
          },
          {
            title: 'q1_c_S',
            name: this.getLabel('q1_c_S'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 47
          },
          {
            title: 'q1_c_S_%_hldg',
            name: this.getLabel('q1_c_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 48
          },
          {
            title: 'q1_d_S',
            name: this.getLabel('q1_d_S'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 49
          },
          {
            title: 'q1_d_S_%_hldg',
            name: this.getLabel('q1_d_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 50
          },
      ],
      sum: {},
      rawDataType: "analysis",
      rawDataApi: "mutual-funds/",
      rawData: [],
      mfSCHCode: ''
    };
  },
  computed: {
    // mfHoldingData: function() {
    //   return this.rawData.filter(function(row, index) {
    //     return index !== "_id" && index !== "co_code";
    //   });
    // },
    // keyFinancialRatios: function(){
    //   return (this.rawData.length > 0 && this.rawData[0]['keyfinancialratiolist'])? this.rawData[0]['keyfinancialratiolist']: [];
    // }
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}
.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/mutual-funds/analysis.vue